<template>
  <div class="container">
    <Header :showHeaderSearch="this.isShowSearch()" :isShowBanner="false" />
    <!-- <div class="wrapper">
      <div class="bg">
        <div class="activity"></div>
        <div class="center-cloud"></div>
        <div class="right-cloud"></div>
        <div class="left-cloud"></div>
      </div>
    </div> -->

    <div class="main-bg1">
      <div class="main-bg1-wrap">
        <section class="main-bg1-eight">
          <div class="main-bg1-title"></div>
          <div class="main-bg1-cloud"></div>
        </section>
      </div>
    </div>

    <div class="main">
      <div class="main-bg23">
        <span
          ><countdown
            :currentTime="Number(info.currentTime)"
            :startTime="Number(info.startDate)"
            :endTime="Number(info.endDate)"
            :tipText="'限时钜惠 距今日结束仅剩'"
            :tipTextEnd="'限时钜惠 距今日结束仅剩'"
            :endText="'活动已经结束'"
            :hourTxt="'时'"
            :minutesTxt="'分'"
            :secondsTxt="'秒'"
          ></countdown
        ></span>
      </div>
      <div class="main-bg31">
        <div class="rush-list">
          <div class="rush-item">
            <div class="corner">{{ this.list[0].title }}</div>
            <div class="sec3-img">
              <h1>充值{{ this.list[0].price }}元</h1>
              <i class="support">支持团队多账号登录</i>
              <h2>
                赠送<span>{{ this.list[0].addprice }}</span
                >元
              </h2>
              <del>原赠{{ this.list[0].oldprice }}元</del>
              <el-button
                type="primary"
                class="buy-button"
                @click="this.list[0].btnEve"
                >立即充值</el-button
              >
            </div>
          </div>
          <div class="rush-item orange">
            <div class="corner">{{ this.list[1].title }}</div>
            <div class="sec3-img">
              <h1>充值{{ this.list[1].price }}元</h1>
              <i class="support">囤够一年，就趁现在！</i>
              <h2>
                赠送<span>{{ this.list[1].addprice }}</span
                >元
              </h2>
              <del>原赠{{ this.list[1].oldprice }}元</del>
              <el-button
                type="primary"
                class="buy-button orange"
                @click="this.list[1].btnEve"
                >立即充值</el-button
              >
            </div>
          </div>
          <div class="rush-item orange">
            <div class="corner">{{ this.list[2].title }}</div>
            <div class="sec3-img">
              <h1>充值{{ this.list[2].price }}元</h1>
              <i class="support">仅此一份，错过后悔一整年</i>
              <h2>
                赠送<span>{{ this.list[2].addprice }}</span
                >元
              </h2>
              <del>原赠{{ this.list[2].oldprice }}元</del>
              <el-button
                type="primary"
                class="buy-button orange"
                @click="this.list[2].btnEve"
                >立即充值</el-button
              >
            </div>
          </div>
        </div>

        <div class="rush-list">
          <div class="rush-item">
            <div class="corner">{{ this.list[3].title }}%</div>
            <div class="sec3-img">
              <h1>充值{{ this.list[3].price }}元</h1>
              <h2>
                赠送<span>{{ this.list[3].addprice }}</span
                >元
              </h2>
              <del>原赠{{ this.list[3].oldprice }}元</del>
              <el-button
                type="primary"
                class="buy-button"
                @click="this.list[3].btnEve"
                >立即充值</el-button
              >
            </div>
          </div>
          <div class="rush-item orange">
            <div class="corner">{{ this.list[4].title }}</div>
            <div class="sec3-img">
              <h1>充值{{ this.list[4].price }}元</h1>
              <h2>
                赠送<span>{{ this.list[4].addprice }}</span
                >元
              </h2>
              <del>原赠{{ this.list[4].oldprice }}元</del>
              <el-button
                type="primary"
                class="buy-button orange"
                @click="this.list[4].btnEve"
                >立即充值</el-button
              >
            </div>
          </div>
          <div class="rush-item orange">
            <div class="corner">{{ this.list[5].title }}</div>
            <div class="sec3-img">
              <h1>充值{{ this.list[5].price }}元</h1>
              <h2>
                赠送<span>{{ this.list[5].addprice }}</span
                >元
              </h2>
              <del>原赠{{ this.list[5].oldprice }}元</del>
              <el-button
                type="primary"
                class="buy-button orange"
                @click="this.list[5].btnEve"
                >立即充值</el-button
              >
            </div>
          </div>
        </div>

        <div class="rush-list">
          <div class="rush-item">
            <div class="corner">{{ this.list[6].title }}</div>
            <div class="sec3-img">
              <h1>充值{{ this.list[6].price }}元</h1>
              <h2>
                赠送<span>{{ this.list[6].addprice }}</span
                >元
              </h2>
              <del>原赠{{ this.list[6].oldprice }}元</del>
              <el-button
                type="primary"
                class="buy-button"
                @click="this.list[6].btnEve"
                >立即充值</el-button
              >
            </div>
          </div>
          <div class="rush-item orange">
            <div class="corner">{{ this.list[7].title }}</div>
            <div class="sec3-img">
              <h1>充值{{ this.list[7].price }}元</h1>
              <h2>
                赠送<span>{{ this.list[7].addprice }}</span
                >元
              </h2>
              <del>原赠{{ this.list[7].oldprice }}元</del>
              <el-button
                type="primary"
                class="buy-button orange"
                @click="this.list[7].btnEve"
                >立即充值</el-button
              >
            </div>
          </div>
          <div class="rush-item orange">
            <div class="corner">{{ this.list[8].title }}</div>
            <div class="sec3-img">
              <h1>充值{{ this.list[8].price }}元</h1>
              <h2>
                赠送<span>{{ this.list[8].addprice }}</span
                >元
              </h2>
              <del>原赠{{ this.list[8].oldprice }}元</del>
              <el-button
                type="primary"
                class="buy-button orange"
                @click="this.list[8].btnEve"
                >立即充值</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 购买列表 -->

    <!-- 页脚 -->
    <div class="main-bg7">
      <img
        src="../../assets/images/activity/img_guide.png"
        @click="gotoSearch()"
      />
    </div>

    <Dialog
      :dialogVisible="dialogTableVisible"
      :dialogPaying="isPaying"
      :curPreferential="currentPreferential"
      :currentPrice="currentPrice"
      :currentCouponId="currentCouponId"
      :curPayType="currentPayType"
      @closeDialog="closePayPop"
      @onPay="changePay"
    />
  </div>
</template>

<script>
import countdown from "@/components/activityCount/countdown.vue";
import Dialog from "./module/dialog.vue";
import { message } from "@/utils/resetMessage";
import Clipboard from "clipboard";
import { getTempUser, getToken } from "../../utils/storage";
import { inviteFriends } from "../../api/auth";
import Header from "@/components/header/header.vue";
export default {
  components: {
    Dialog,
    countdown,
    Header,
  },
  data() {
    return {
      isLoggedIn: false, //是否登录
      currentPrice: 0, //价格
      currentPreferential: 0, //优惠
      currentPayType: "alipay", //支付类型
      dialogTableVisible: false, //支付弹窗
      currentCouponId: 0, //优惠券id
      isPaying: false, //是否还在支付中
      inviteCode: "", //邀请码
      info: {
        currentTime: "",
        startDate: "",
        endDate: "",
      },
      list: [
        {
          title: "抄底618 4.6折",
          subTitle: "",
          price: 3000,
          addprice: 3500,
          oldprice: 3000,
          url: "",
          btnEve: () => {
            this.openPayPop(0);
          },
        },
        {
          title: "底价仅限 3 份",
          subTitle: "",
          url: "",
          price: 5000,
          addprice: 6000,
          oldprice: 5000,
          btnEve: () => {
            this.openPayPop(1);
          },
        },
        {
          title: "仅限1份 速抢！",
          subTitle: "",
          url: "",
          price: 8000,
          addprice: 10000,
          oldprice: 8000,
          btnEve: () => {
            this.openPayPop(2);
          },
        },
        {
          title: "限时赠送40%",
          subTitle: "",
          url: "",
          price: 500,
          addprice: 200,
          oldprice: 100,
          btnEve: () => {
            this.openPayPop(3);
          },
        },
        {
          title: "抄底618 6折",
          subTitle: "",
          url: "",
          price: 1000,
          addprice: 600,
          oldprice: 400,
          btnEve: () => {
            this.openPayPop(4);
          },
        },
        {
          title: "限时5折福利！",
          subTitle: "",
          url: "",
          price: 2000,
          addprice: 1800,
          oldprice: 1500,
          btnEve: () => {
            this.openPayPop(5);
          },
        },
        {
          title: "新手尝鲜体验包",
          subTitle: "",
          url: "",
          price: 50,
          addprice: 10,
          oldprice: 5,
          btnEve: () => {
            this.openPayPop(6);
          },
        },
        {
          title: "限时翻倍加赠",
          subTitle: "",
          url: "",
          price: 100,
          addprice: 30,
          oldprice: 15,
          btnEve: () => {
            this.openPayPop(7);
          },
        },
        {
          title: "限时翻倍赠送！",
          subTitle: "",
          url: "",
          price: 300,
          addprice: 100,
          oldprice: 50,
          btnEve: () => {
            this.openPayPop(8);
          },
        },
      ],
    };
  },
  mounted() {
    this.isLoggedIn =
      getToken() != "null" && getToken() != "" && getTempUser() != "temp"
        ? true
        : false;
    this.info.currentTime = new Date();
    var timedate = this.getNowFormatDate();
    this.info.startDate = new Date(timedate + " 00:00:00");
    this.info.endDate = new Date(timedate + " 24:00:00");
    this.invateFriend();
    this.$store.commit("updateShowPost", false);
  },
  methods: {
    isShowSearch() {
      let flag = false;
      if (
        this.$store.state.common.userInfo.blance !== null &&
        this.$store.state.common.userInfo.blance > 0
      ) {
        flag = true;
      } else {
        flag = false;
      }
      return flag;
    },
    invateFriend() {
      inviteFriends()
        .then((result) => {
          // var fullPath = window.location.href;
          // var oLastPath = this.$route.path;
          // var nLastPath = "/registered?faiUuid=" + result;
          // var link = fullPath.replace(oLastPath, nLastPath);
          //document.getElementById("invite_link").value ="邀请你加入："+link+"  \n国内外高质量素材都在Taogetu，注册记得填邀请码："+result;//link;
          this.inviteCode = result;
        })
        .catch((error) => {});
    },
    copy_invite(e) {
      //let input = document.createElement('input');
      var fullPath = window.location.href;
      var oLastPath = this.$route.path;
      var nLastPath = "/registered?faiUuid=" + this.inviteCode;
      var link = fullPath.replace(oLastPath, nLastPath);
      var text =
        "邀请你加入：" +
        link +
        "  \n国内外高质量素材都在Taogetu，注册记得填邀请码：" +
        this.inviteCode;
      // input.id = 'creatDom';
      // document.body.appendChild(input);
      // input.select();
      // document.execCommand('copy');
      // document.body.removeChild(input);
      const clipboard = new Clipboard(e.target, { text: () => text });
      clipboard.on("success", (e) => {
        message.success({
          message: "复制成功",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        message.success({
          message: "复制失败，请重试",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.onClick(e);
    },

    closePayPop() {
      this.dialogTableVisible = false;
    },
    changePay(flag) {
      //更换支付状态
      this.isPaying = flag;
    },
    //点击充值跳转到支付窗口
    openPayPop(index) {
      if (this.isLoggedIn) {
        //增加赠送值
        this.currentPrice = this.list[index].price;
        this.currentPreferential = this.list[index].addprice;
        if (this.currentPrice <= 3000) {
          //随机
          this.payTypeIndex = Math.round(Math.random() * 10) % 2;
          if (this.payTypeIndex == 1) {
            this.currentPayType = "alipay";
          } else {
            this.currentPayType = "wechat";
          }
        }
        this.dialogTableVisible = true;
      } else {
        message.error({
          message: "您还没登录用户，请登录",
          showClose: true,
          duration: 4000,
          offset: 100,
        });
        //跳转登录
        this.$router.push({ path: "/login" });
      }
    },
    gotoSearch() {
      this.$router.push({ path: "/materialCenter" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/activity.scss";
</style>
